import Vue from 'vue'
import Router from 'vue-router'
import Wizard from '@/components/Wizard'
import Book from '@/components/Book'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Wizard',
      component: Wizard
    },
    {
      path: '/book',
      name: 'Book',
      component: Book
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js